import React, { useEffect, useState } from "react";
import "./CompanyDetails.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Dashboard/Navbar";
import receivelogo from "../Images/Received.png";
import sentlogo from "../Images/Sent.png";
import locationlogo from "../Images/locationc.svg";
import breadcrumb from "../Images/breadcrumbhome.svg";
import Telegram from "../Images/Telegram-Company.png";
import Reddit from "../Images/reddit-company.png";
import Group from "../Images/Group-Company.png";
import Twitter from "../Images/Twitter-Company.png";
import Git from "../Images/git-company.png";
import EditProfile from "./Dashboard/EditProfile";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "./Firebase/firebase";
import Footer from "./Dashboard/Footer";
import VerifyIcon from "../Images/VerificationIcon.png";
import Modal from "./Dashboard/ModalCategory";
import acceptsvg from "../Images/acceptnew.svg";
import sentsvg from "../Images/sent.svg";
import Raisalogo from "../Images/RaisaN.svg";
import dis from "../Images/discovernew.svg";
import inb from "../Images/inboxnew.svg";
import req from "../Images/requestnew.svg";
import sav from "../Images/savenew.svg";
import noti from "../Images/notificationnew.svg";
import disb from "../Images/discoverblue.svg";
import inbb from "../Images/inboxblue.svg";
import reqb from "../Images/requestblue.svg";
import savb from "../Images/saveblue.svg";
import notib from "../Images/notifiyblue.svg";
import InsufficientRequests from "./InsufficientRequests";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//import verify from "../Images/verify.png"

const CompanyDetails = () => {
  const [isEditprofile, setIsEditProfile] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [requestTypes, setRequestTypes] = useState([]);
  const [message, setMessage] = useState("");
  const [isRequestTypeOpen, setIsRequestTypeOpen] = useState(false);
  const [userConnectsList, setUserConnectsList] = useState([]);
  const [matchingRequests, setMatchingRequests] = useState([]);
  const [myproject, setMyProject] = useState([]);
  const [requestSent, setRequestSent] = useState(0);
  const [requestReceived, setRequestReceived] = useState(0);
  const [userConnectsDocId, setUserConnectsDocId] = useState(null);
  const [isVerified, setIsVerified] = useState(false);
  const [showMorePi, setShowMorePi] = useState(false);
  const [showMoreEc, setShowMoreEc] = useState(false);
  const [showMore, setShowMore] = useState(false);

  /* category code  */
  const [showAllCategories, setShowAllCategories] = useState(false);
  /* blockchain (eco system)*/
  const [showAllBlockchains, setShowAllBlockchains] = useState(false);

  const [showAllPartnerships, setShowAllPartnerships] = useState(false);

  const [showAllRequestTypes, setShowAllRequestTypes] = useState(false);

  const [hoveredItem, setHoveredItem] = useState(null);
  const [buttonActive, setButtonActive] = useState(null);
  const [insufficientOpen, setInsufficientOpen] = useState(false);
  const location = useLocation();
  const handleButtonClick = (button) => {
    setButtonActive(button);
    localStorage.setItem("buttonActive", button);
  };

  const [isInvalid, setIsInvalid] = useState(false); // Validation state

  const handleMessageChange = (e) => {
    const inputMessage = e.target.value;

    if (inputMessage.trim().length < 200) {
      setIsInvalid(true); // Mark input as invalid
      toast.error("Minimum 200 characters required.", {
        position: "top-center",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      setIsInvalid(false); // Input is valid
    }

    setMessage(inputMessage); // Always update message state
  };

  useEffect(() => {
    const savedActiveButton = localStorage.getItem("buttonActive");
    if (savedActiveButton) {
      setButtonActive(savedActiveButton);
    }

    const currentPath = location.pathname.replace("/", "");
    setButtonActive(currentPath);
  }, [location.pathname]);

  // Handle mouse enter and leave for hover state
  const handleMouseEnter = (item) => {
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("selectedProject");
    const auth = getAuth(); // Get the current authentication instance
    signOut(auth)
      .then(() => {
        // Sign-out successful, redirect user to login page
        navigate("/login"); // Redirecting to login page after logout
      })
      .catch((error) => {
        // An error happened during logout
        console.error("Logout Error:", error);
      });
  };
  useEffect(() => {
    const auth = getAuth();
    // Listen for authentication state changes
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user);
      }
    });
    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, []);
  document.body.style.background = "rgba(234, 239, 255, 1)";
  const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));

  // Fetch user verification status
  const fetchUserVerification = async (userId) => {
    try {
      const usersRef = collection(db, "User"); // Assuming your collection name is 'Users'
      const userQuery = query(usersRef, where("id", "==", userId));
      const userSnapshot = await getDocs(userQuery);
      if (!userSnapshot.empty) {
        const userData = userSnapshot.docs[0].data(); // Get the first matched document
        setIsVerified(userData.verified); // Check if the user is verified
      }
    } catch (error) {
      console.error("Error fetching user verification:", error);
      setIsVerified(false); // Default to false if error occurs
    }
  };

  useEffect(() => {
    // Ensure selectedProject and userId exist
    if (selectedProject.userId) {
      fetchUserVerification(selectedProject.userId); // Fetch verification status
    }
  }, [selectedProject.userId, db]);

  const handleToggleModal = async () => {
    try {
      // Fetch the UserSubs document for the current user
      const userSubsRef = collection(db, "UserSubs");
      const userSubsQuery = query(
        userSubsRef,
        where("userId", "==", currentUser?.uid)
      );
      const userSubsSnapshot = await getDocs(userSubsQuery);
      console.log("request checking1", userSubsSnapshot);
      if (userSubsSnapshot.empty) {
        toast.error("No subscription data found for the user.", {
          position: "top-center",
          autoClose: 3000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        return;
      }

      const userSubsDoc = userSubsSnapshot.docs[0];
      console.log("request checking", userSubsDoc);
      const userSubsData = userSubsDoc.data();
      console.log("request checking", userSubsData);
      // Check if user has enough credits
      if (userSubsData?.credits <= 0) {
        setInsufficientOpen(true);

        return;
      }

      setIsModalOpen(!isModalOpen);
    } catch (e) {
      console.error("Internal server error: ", e);
    }
  };
  const fetchUserConnectCounts = async (
    userId,
    setRequestSent,
    setRequestReceived
  ) => {
    try {
      // Reference to the UserConnects collection
      const connectsRef = collection(db, "UserConnects");

      // Create query to match userId
      const userQuery = query(connectsRef, where("userId", "==", userId));

      // Create query to match toUserId
      const toUserQuery = query(connectsRef, where("toUserId", "==", userId));

      // Run both queries in parallel
      const [userSnapshot, toUserSnapshot] = await Promise.all([
        getDocs(userQuery),
        getDocs(toUserQuery),
      ]);

      // Set state for requestSent and requestReceived
      setRequestSent(userSnapshot.size); // Count of requests sent (userId)
      setRequestReceived(toUserSnapshot.size); // Count of requests received (toUserId)
    } catch (error) {
      console.error("Error fetching data:", error);
      setRequestSent(0); // Default to 0 if error occurs
      setRequestReceived(0); // Default to 0 if error occurs
    }
  };

  useEffect(() => {
    // Ensure selectedProject and userId exist
    if (selectedProject?.userId) {
      fetchUserConnectCounts(
        selectedProject.userId,
        setRequestSent,
        setRequestReceived
      );
    }
  }, [selectedProject, db]);

  // Function to handle cancel request (delete operation)
  const handleCancelRequest = async (docid) => {
    try {
      // Get the document reference for UserConnects
      const docRef = doc(db, "UserConnects", docid);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        console.error("Document not found!");
        return;
      }

      const docData = docSnap.data();

      // Fetch the logged-in user's UserProject to get fromProjectId
      const userProjectQuery = query(
        collection(db, "UserProject"),
        where("userId", "==", currentUser?.uid) // Assuming currentUser is available in scope
      );

      const userProjectSnapshot = await getDocs(userProjectQuery);
      const userProjects = userProjectSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const loggedInUserProject =
        userProjects.length > 0 ? userProjects[0] : null;

      if (!loggedInUserProject) {
        console.error("No UserProject found for the logged-in user!");
        return;
      }

      const fromProjectId = loggedInUserProject.id;

      // Query to fetch related UserProject for the recipient (docData.userId)
      const recipientProjectQuery = query(
        collection(db, "UserProject"),
        where("userId", "==", docData.userId)
      );

      const recipientProjectSnapshot = await getDocs(recipientProjectQuery);
      const recipientProjects = recipientProjectSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const recipientProject =
        recipientProjects.length > 0 ? recipientProjects[0] : null;

      if (!recipientProject) {
        console.error("No matching UserProject found for the recipient!");
        return;
      }

      const toProjectId = recipientProject?.id;

      // Delete the document
      await deleteDoc(docRef);
      toast("Request is cancelled!!.", {
        position: "top-center",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      //UserEvent Cancel Creation
      await addDoc(collection(db, "userEvent"), {
        createdAt: serverTimestamp(),
        eventName: "REQUEST_CANCEL",
        fromProjectId: myproject?.id || "",
        fufillmentId: "",
        status: "NEW",
        toProjectId: selectedProject?.id || "",
        toUserId: selectedProject?.userId || "",
        updatedAt: serverTimestamp(),
        userId: currentUser?.uid || "",
      });
      await fetchUserConnects();
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };

  const handleRequestTypeChange = (type) => {
    setRequestTypes((prev) => {
      if (prev.includes(type)) {
        // Uncheck: remove type from array
        return prev.filter((t) => t !== type);
      } else {
        // Check: add type to array
        return [...prev, type];
      }
    });
  };

  const handleAccept = async (docid) => {
    try {
      // Get the document reference for UserConnects
      const docRef = doc(db, "UserConnects", docid);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        console.error("Document not found!");
        return;
      }

      const docData = docSnap.data();
      const message = docData.message;
      console.log("new message check",message)

      // Fetch the logged-in user's UserProject to get fromProjectId
      const userProjectQuery = query(
        collection(db, "UserProject"),
        where("userId", "==", currentUser?.uid) // Assuming currentUser is available in scope
      );

      const userProjectSnapshot = await getDocs(userProjectQuery);
      const userProjects = userProjectSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const loggedInUserProject =
        userProjects.length > 0 ? userProjects[0] : null;

      if (!loggedInUserProject) {
        console.error("No UserProject found for the logged-in user!");
        return;
      }

      const fromProjectId = loggedInUserProject.id;

      // Query to fetch related UserProject for the recipient (docData.userId)
      const recipientProjectQuery = query(
        collection(db, "UserProject"),
        where("userId", "==", docData.userId)
      );

      const recipientProjectSnapshot = await getDocs(recipientProjectQuery);
      const recipientProjects = recipientProjectSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const recipientProject =
        recipientProjects.length > 0 ? recipientProjects[0] : null;

      if (!recipientProject) {
        console.error("No matching UserProject found for the recipient!");
        return;
      }

      const toProjectId = recipientProject?.id;

      // Update the UserConnects document status
      await updateDoc(docRef, {
        status: "Accepted",
        lastCreatedAt: serverTimestamp(),
      });

      // Create a new UserEvent document
      await addDoc(collection(db, "userEvent"), {
        createdAt: serverTimestamp(),
        eventName: "REQUEST_ACCEPT",
        fromProjectId: fromProjectId || "", // fromProjectId for the logged-in user
        fufillmentId: "",
        status: "NEW",
        toProjectId: toProjectId || "", // toProjectId for the recipient
        toUserId: recipientProject?.userId || "",
        updatedAt: serverTimestamp(),
        userId: currentUser?.uid || "",
      });

      const inboxRef = collection(db, "inbox");
      await addDoc(inboxRef, {
        dateTime: new Date(),
        fromProjectId: myproject?.id,
        fromUserId: currentUser?.uid || "",
        message: message || "",
        toProjectId: selectedProject?.id || "",
        toUserId: selectedProject?.userId || "",
      });


      await fetchUserConnects();

      toast("Request has been accepted!", {
        position: "top-center",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      console.error("Error in Accepting Request:", error);
    }
  };

  const handleDeny = async (docid) => {
    try {
      // Get the document reference for UserConnects
      const docRef = doc(db, "UserConnects", docid);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        console.error("Document not found!");
        return;
      }

      const docData = docSnap.data();

      // Fetch the logged-in user's UserProject to get fromProjectId
      const userProjectQuery = query(
        collection(db, "UserProject"),
        where("userId", "==", currentUser?.uid) // Assuming currentUser is available in scope
      );

      const userProjectSnapshot = await getDocs(userProjectQuery);
      const userProjects = userProjectSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const loggedInUserProject =
        userProjects.length > 0 ? userProjects[0] : null;

      if (!loggedInUserProject) {
        console.error("No UserProject found for the logged-in user!");
        return;
      }

      const fromProjectId = loggedInUserProject.id;

      // Query to fetch related UserProject for the recipient (docData.userId)
      const recipientProjectQuery = query(
        collection(db, "UserProject"),
        where("userId", "==", docData.userId)
      );

      const recipientProjectSnapshot = await getDocs(recipientProjectQuery);
      const recipientProjects = recipientProjectSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const recipientProject =
        recipientProjects.length > 0 ? recipientProjects[0] : null;

      if (!recipientProject) {
        console.error("No matching UserProject found for the recipient!");
        return;
      }

      const toProjectId = recipientProject?.id;
      await updateDoc(doc(db, "UserConnects", docid), {
        status: "Denied",
        lastCreatedAt: serverTimestamp(),
      });

      //UserEvent Deny Creation
      await addDoc(collection(db, "userEvent"), {
        createdAt: serverTimestamp(),
        eventName: "REQUEST_DENY",
        fromProjectId: fromProjectId || "", // fromProjectId for the logged-in user
        fufillmentId: "",
        status: "NEW",
        toProjectId: toProjectId || "", // toProjectId for the recipient
        toUserId: recipientProject?.userId || "",
        updatedAt: serverTimestamp(),
        userId: currentUser?.uid || "",
      });

      await fetchUserConnects();
      toast("Request has been rejected!", {
        position: "top-center",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      console.error("Error in Denying Request", error);
    }
  };

  /* const handleSendSaveRequest = async () => {




    if (requestTypes.length == 0) {
      alert("Please Select Your Request Type");
      return;
    }




    try {
      // Add a new document to the UserConnects collection
      const docRef = await addDoc(collection(db, "UserConnects"), {
        createdAt: new Date(), // current timestamp
        projectId: selectedProject?.id || "", // project ID (from selected project)
        status: "Pending", // initial status is "pending"
        toUserId: selectedProject?.userId || "", // the user who owns the project
        userId: currentUser?.uid || "", // the current user sending the request
        requestTypes: [...requestTypes], // Array of selected request types
        message: message, // The message input from the user
        location: myproject?.country || "", //fromuser location
        name: myproject?.name || "", //fromuser project name
        profilePicture: myproject?.profilePicture || "",
        toname: selectedProject?.name || "",
        tolocation: selectedProject?.country || "",
        toprofilePicture: selectedProject?.profilePicture || "",
        lastCreatedAt: new Date(),
        tocategory: selectedProject?.category || [],
        tofundingstage: selectedProject?.fundingStatus || [],
        toecosystem: selectedProject?.blockchain || [],
        topartnershipinterest: selectedProject?.partnershipInterest || [],
      });
      

      console.log("Document written with ID: ", docRef.id);
      setUserConnectsDocId(docRef.id);
      setIsModalOpen(false);
      setIsRequestTypeOpen(false);
      setMessage("");
      await fetchUserConnects();
      await fetchMyProjectData();
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  }; */

  const handleSendSaveRequest = async () => {
    if (requestTypes.length === 0) {
      toast("Please Select Your Request Type", {
        position: "top-center", // Position the toast at the center top
        autoClose: 3000, // Automatically close after 3 seconds
        // hideProgressBar: true, // Hide the progress bar
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    if (message.length < 200) {
      toast.error("You need to enter at least 200 characters to send.", {
        position: "top-center", // Position the toast at the center top
        autoClose: 3000, // Automatically close after 3 seconds
        // hideProgressBar: true, // Hide the progress bar
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    try {
      // Fetch the UserSubs document for the current user
      const userSubsRef = collection(db, "UserSubs");
      const userSubsQuery = query(
        userSubsRef,
        where("userId", "==", currentUser?.uid)
      );
      const userSubsSnapshot = await getDocs(userSubsQuery);
      console.log("request checking1", userSubsSnapshot);
      // if (userSubsSnapshot.empty) {
      //   alert("No subscription data found for the user.");
      //   return;
      // }

      const userSubsDoc = userSubsSnapshot?.docs[0];
      console.log("request checking", userSubsDoc);
      const userSubsData = userSubsDoc.data();
      console.log("request checking", userSubsData);
      // Check if user has enough credits
      if (userSubsData?.credits <= 0) {
        // setInsufficientOpen(true);
        toast.error("No Credits Avaiable To Sent The Request", {
          position: "top-center", // Position the toast at the center top
          autoClose: 3000, // Automatically close after 3 seconds
          // hideProgressBar: true, // Hide the progress bar
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        return;
      }
      // checking alreday doc is created or not send request
      const q = query(
        collection(db, "UserConnects"),
        where("userId", "==", currentUser?.uid || ""),
        where("toUserId", "==", selectedProject?.userId || "")
      );

      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // If a matching document exists, show an alert
        toast.error("Request has already send  to this project ", {
          position: "top-center", // Position the toast at the center top
          autoClose: 3000, // Automatically close after 3 seconds
          // hideProgressBar: true, // Hide the progress bar
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        return;
      }
      // Proceed with adding a document to UserConnects
      const docRef = await addDoc(collection(db, "UserConnects"), {
        createdAt: new Date(),
        projectId: selectedProject?.id || "",
        status: "Pending",
        toUserId: selectedProject?.userId || "",
        userId: currentUser?.uid || "",
        requestTypes: [...requestTypes],
        message: message,
        location: myproject?.country || "",
        name: myproject?.name || "",
        profilePicture: myproject?.profilePicture || "",
        toname: selectedProject?.name || "",
        tolocation: selectedProject?.country || "",
        toprofilePicture: selectedProject?.profilePicture || "",
        lastCreatedAt: new Date(),
        tocategory: selectedProject?.category || [],
        tofundingstage: selectedProject?.fundingStatus || [],
        toecosystem: selectedProject?.blockchain || [],
        topartnershipinterest: selectedProject?.partnershipInterest || [],
      });

      //UserEvent Sent Creation

      await addDoc(collection(db, "userEvent"), {
        createdAt: serverTimestamp(),
        eventName: "REQUEST_SENT",
        fromProjectId: myproject?.id || "",
        fufillmentId: "",
        status: "NEW",
        toProjectId: selectedProject?.id || "",
        toUserId: selectedProject?.userId || "",
        updatedAt: serverTimestamp(),
        userId: currentUser?.uid || "",
      });

      // const inboxRef = collection(db, "inbox");
      // await addDoc(inboxRef, {
      //   dateTime: new Date(),
      //   fromProjectId: myproject?.id,
      //   fromUserId: currentUser?.uid || "",
      //   message: message || "",
      //   toProjectId: selectedProject?.id || "",
      //   toUserId: selectedProject?.userId || "",
      // });

      console.log("Document written with ID: ", docRef.id);
      setUserConnectsDocId(docRef.id);
      setIsModalOpen(false);
      setIsRequestTypeOpen(false);
      setMessage("");

      // Update UserSubs with new credits and usedCredits values
      await updateDoc(userSubsDoc.ref, {
        credits: userSubsData.credits - 1,
        usedCredits: (userSubsData.usedCredits || 0) + 1,
      });

      // Refresh data after the request
      await fetchUserConnects();
      await fetchMyProjectData();
      toast.success("Request  Send Successfully ", {
        position: "top-center", // Position the toast at the center top
        autoClose: 3000, // Automatically close after 3 seconds
        // hideProgressBar: true, // Hide the progress bar
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (e) {
      console.error("Error adding document or updating credits: ", e);
    }
  };
  //fetch userconnects data
  const fetchUserConnects = async () => {
    try {
      // Reference to the UserConnects collection
      const userConnectsCollection = collection(db, "UserConnects");

      // Fetch all documents from the collection
      const querySnapshot = await getDocs(userConnectsCollection);

      // Map through the documents to create a list
      const userConnectsList = querySnapshot.docs.map((doc) => ({
        id: doc.id, // Document ID
        ...doc.data(), // Document data
      }));

      console.log("Fetched User Connects: ", userConnectsList);
      setUserConnectsList(userConnectsList);
      // Use filter to find all matches for selectedProject.id
      const matchingRequests = userConnectsList.filter(
        (ele) =>
          (ele.toUserId === selectedProject.userId &&
            ele.userId === currentUser?.uid) ||
          (ele.toUserId === currentUser?.uid &&
            ele.userId === selectedProject.userId)
      );
      console.log("selectedProjecttest", selectedProject.id);
      console.log("testing", matchingRequests);
      setMatchingRequests(matchingRequests);
    } catch (e) {
      console.error("Error fetching User Connects: ", e);
      return [];
    }
  };

  const fetchMyProjectData = async () => {
    try {
      const userProjectsCollection = collection(db, "UserProject");
      const userProjectsQuery = query(
        userProjectsCollection,
        where("userId", "==", currentUser?.uid)
      );

      const querySnapshot = await getDocs(userProjectsQuery);

      // Map through the documents to create a list
      const userProject = querySnapshot.docs.map((doc) => ({
        id: doc.id, // Document ID
        ...doc.data(), // Document data
      }));

      setMyProject(userProject[0]);
    } catch (e) {
      console.error("Error fetching User Connects: ", e);
    }
  };
  useEffect(() => {
    fetchMyProjectData();
  }, [currentUser?.uid, db, isEditprofile]);

  useEffect(() => {
    fetchUserConnects();
  }, [selectedProject]);

  /* category code  */
  // Decide which category array to use based on the user
  const categories =
    selectedProject.userId === currentUser?.uid
      ? myproject?.category || []
      : selectedProject?.category || [];

  const visibleCategories = showAllCategories
    ? categories
    : categories.slice(0, 14); // Show first 14, rest hidden */
  /* category code end  */

  /* blockchain (ecosystem) */
  const blockchains =
    selectedProject.userId === currentUser?.uid
      ? myproject?.blockchain || []
      : selectedProject?.blockchain || [];

  const visibleBlockchains = showAllBlockchains
    ? blockchains
    : blockchains.slice(0, 14);

  /* blockchain (ecosystem) */

  const partnershipInterests =
    selectedProject.userId === currentUser?.uid
      ? myproject?.partnershipInterest || []
      : selectedProject?.partnershipInterest || [];

  const visiblePartnershipInterests = showAllPartnerships
    ? partnershipInterests
    : partnershipInterests.slice(0, 14);

  const requesttypes =
    selectedProject.userId === currentUser?.uid
      ? myproject?.requestType || []
      : selectedProject?.requestType || [];

  const visibleRequestTypes = showAllRequestTypes
    ? requestTypes
    : requestTypes.slice(0, 14);

  const handleMoreClick = () => {
    setShowMore(true);
  };

  const closeModal = () => {
    setShowMore(false);
    setShowMorePi(false);
    setShowMoreEc(false);
  };

  return (
    <div className="companydetails-container">
      <div className="companydetails-navbar">
        <Navbar />
      </div>
      <div className="request-page-mobile-navbar">
        <div className="req-navbar-m">
          <div className="req-nav-cntr">
            <img
              className="req-raisa-logo-img"
              src={Raisalogo}
              alt="raisa"
              onClick={() => {
                navigate("/dashboard");
              }}
            />
            <ul className="req-header-ul">
              {/* <li
        className="headerli dis"
       
      >
          <Link to="/dashboard" style={{ textDecoration: 'none'}} >
        <img className="headerli-img " src={dis} alt="discover" />
        
       
          
          </Link>
        
      </li> */}
              <li
                className="req-headerli"
                onMouseEnter={() => handleMouseEnter("inbox")}
                onMouseLeave={handleMouseLeave}
              >
                <Link
                  to="/inbox"
                  style={{ textDecoration: "none", height: "18px" }}
                >
                  <div>
                    <svg
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="18"
                        height="18"
                        fill="url(#pattern0_3137_814)"
                      />

                      <defs>
                        <pattern
                          id="pattern0_3137_814"
                          patternContentUnits="objectBoundingBox"
                          width="1"
                          height="1"
                        >
                          <use
                            href="#image0_3137_814"
                            transform="scale(0.015625)"
                          />
                        </pattern>

                        <image
                          id="image0_3137_814"
                          width="64"
                          height="64"
                          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABuAAAAbgBl1XCjwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAVaSURBVHic7ZpraB1FFMd/5+ah9AFprJj4wWjsWyrGaIVatUjViqYg1gSh/SJWEMFvghRfiCB+EKsgtgq2qBRpfSBaqFQUhYAxaTGtlNq0okZtEvBRra/Y5PhhZtO5k9x7d/fu3U2T/GFg787MOf/zv/PeEVVlOiOXNYGsMe0FqM7KsYhUAXfYn++q6kgWPLJsAe3AbpvasyKRpQDXFHhOFdN+DJgRIGsCWWNGgKwJZI0ZAbImkDWmvQCxlsIi0ggsBC5ybHyjqp8lRayE/+uBZufVKPAT0Ad8r1G2uKoaKgECdACdgBZImyPY2+LU2xKh3uYi/hX4GrgXOCeMvVBdQETmAG8DbwIrixRdHFb4MlDKxyLgFaDTttSiKNkFRKQW+Bi42sv6E/gCGLa/vwWeLmUvATwG/A1c7LzLAa1AvfOuFegSkWtVtb+gtRBN7lnym9geYDVQG7bZJtkFitirAlYBL/t8i9YrYfRKzAATGPswbOD2X7kcyMUVAKgFlscQ40VPhLviCrDPMfIlMCsCifdsvSPA0qgCANcBgzb/+Rit4QOXe2QBgJs8FW+MSGLQqXsSWBdWAGATZmwJ8rtitIJm4LRj4+bQAmCmvP1O5b0xCGz0CIxiBjApJABmUH7BE/4vYE1U/9beLsfOvigC3O0RvyImgTXAz15A7wBzfAGAeV6XU+AHoDWOb+t/hWevpaQAduA57lR6Iy4Bpyke9Ih85YwRwczS55X5HGgox7f1/6ljc2cYAR50KvwLXJIAidnAW16AxdJrhFzJhfB9u2P3P6CpoADAXGDI75sJERHgEfKnVT+NAA8l5dPxe7hQTH7hJ52CvwPzkyRjfbRhZgU/+JPAbUn7sz7vcfycAuaNEwBosJlBwUcrQcb6WorZtAS+jjHBWiFBf7WY3WLgb2zT5hZ6ySlwAphdKULWX51tcU8B9ZX0Zf097MQ3EIwxQeYiO0AEBe6vNKG0kxX8DyfGTa4Au52Mo0B11oQrJMJzTpxHAKkWkRXAes6gE1gvIkTAb6q6N0qFciAic4FbiX6kd8J5XgysA3if8PNzsfQRcG4K/2IL0J8gZ0YSMqbAfSkIsCdBviNiHwIcwAyGUXAesMA+9wFLVHU0oo1QEJHLgEOYxQ2YDdvpiGZqMOccY3AVibz2Bi7ELJkDG3dW8N/f7vjpjmmjwYu5PAGs0VcdG5H37jGFbp9MAiwjf42/ugICPOPYPw5UTRoBrGF3NumkzENTz3Yz+fuHB8qwVTEBVnm2dmJPf8oMfj5mcRbYHSTC2WRqAljj2z1724CFMW3lMB9hujybHWVyzBPAnwYbVXWAmBCROszpcZOXdRT4BPgnpKnzgVswU6yLXaraEZef5dhA/oowuRZgFW4Eejy7SaRtJLBHoZJdwHEyC7P9/DGBwLsp8mFjUnUBH/a74kpgCXApZhUWBqcwByYHVbU3KT6WU14XqKgAkxG+ANP+hkiO/BYQ6RDgLIUbo+YwB5IBFjD14cZ4LIeZsgJclTKZLODG2JPDTDMTZU5VuDF2+y1grYhckDKh1GBjW+u86slhTlWCqa8e2Jo2sRSxlTP3iAaA/cHqqI381deGpFZekyUBG7wY21QVt8AOJ3MYeAKoyZp4AoHX2FjcGyc7xvKdgnWMP27uBW4gwcONFAOvtdx7vZj6gbqgXHBdBQARWQa8jndqatU7hBkvfo3R99LEPMwdweUYEVwcADaq6uGxNxMoVw08Tn6TOdvTMOZ+0rjtdLEm1II55xtKiWQl0pCNYdzdoAm7QCGISBNmAeFfR52M+AXTVXtU9btShUMJMJUxsx3OmkDW+B/duuxQQ5xJqQAAAABJRU5ErkJggg=="
                        />
                      </defs>
                    </svg>
                  </div>
                  {/* <img className="headerli-img"  src={hoveredItem === 'inbox' || buttonActive === 'inbox' ? inbb : inb} alt="inbox"  / > */}
                </Link>
              </li>

              <li
                className="req-headerli"
                onMouseEnter={() => handleMouseEnter("requestpage")}
                onMouseLeave={handleMouseLeave}
              >
                <Link
                  to="/requestpage"
                  style={{ textDecoration: "none", height: "18px" }}
                >
                  <img
                    className="headerli-img"
                    src={
                      hoveredItem === "requestpage" ||
                      buttonActive === "requestpage"
                        ? reqb
                        : req
                    }
                    alt="request"
                  />
                </Link>
              </li>
              <li className="req-headerli" onClick={() => alert("Coming Soon")}>
                <Link style={{ textDecoration: "none", height: "18px" }}>
                  <img className="headerli-img" src={sav} alt="saved" />
                </Link>
              </li>
              <li className="req-headerli" onClick={() => alert("Coming Soon")}>
                {" "}
                <Link style={{ textDecoration: "none", height: "18px" }}>
                  <img
                    className="headerli-img"
                    src={noti}
                    alt="notifications"
                  />
                </Link>
              </li>
            </ul>

            <button className="req-logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      </div>
      <div className="companydetails-sub">
        <div className="bread-container">
          <div className="bbcmb" aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <img src={breadcrumb} alt="home" />
                <div className="a-div">
                  <a href="/dashboard">Dashboard</a>
                </div>
              </li>

              <li class="breadcrumb-item active" aria-current="page">
                {selectedProject?.userId === currentUser?.uid
                  ? myproject?.name || "Default Company Name"
                  : selectedProject?.name || "Default Company Name"}
              </li>
            </ol>
          </div>
        </div>

        <div className="company-details">
          {/* Header */}
          <div className="header-container">
            <div className="header-section">
              <img
                className="cover-photo"
                src={
                  selectedProject.userId === currentUser?.uid
                    ? myproject?.coverPicture
                    : selectedProject?.coverPicture
                }
                alt="cover-picture"
              />
            </div>
            <div className="subconatiner">
              <div className="profile-container">
                <div className="company-profile-logo">
                  <img
                    className="company-profile-photo"
                    src={
                      selectedProject?.userId === currentUser?.uid
                        ? myproject?.profilePicture
                        : selectedProject?.profilePicture
                    }
                    alt="profile-picture"
                  />
                </div>

                <div className="company-profile-text">
                  <div className="companyname-oneliner-container">
                    <div className="companyname-verification">
                      <h4 className="company-name">
                        {selectedProject?.userId === currentUser?.uid
                          ? myproject?.name || ""
                          : selectedProject?.name ||
                            ""}{" "}
                        {isVerified && (
                          <img
                            src={VerifyIcon}
                            alt="verified"
                            className="verified-icon-c"
                          />
                        )}
                      </h4>
                    </div>
                    <p className="oneliner">
                      {selectedProject?.userId === currentUser?.uid
                        ? myproject?.oneLiner ||
                          ""
                        : selectedProject?.oneLiner ||
                          ""}
                    </p>
                  </div>
                  <div className="location">
                    <img
                      className="location-img"
                      src={locationlogo}
                      alt="location"
                    />
                    <span className="city-conuntry">
                      {/* {selectedProject?.userId === currentUser?.uid
                        ? myproject?.city || ""
                        : selectedProject?.city || ""}
                      ,{" "} */}
                      {selectedProject?.userId === currentUser?.uid
                        ? myproject?.country || ""
                        : selectedProject?.country || ""}{" "}
                    </span>
                  </div>
                </div>

                {/* <button className="edit-profile-btn">Edit Profile</button> */}
              </div>

              <div className="inner">
                {currentUser?.uid === selectedProject?.userId ? (
                  <>
                    <button
                      className="send-request-btn"
                      onClick={() => setIsEditProfile(true)}
                    >
                      Edit Profile
                    </button>
                    {isEditprofile && (
                      <div
                        style={{
                          position: "fixed",
                          top: 0,
                          right: 0,
                          bottom: 0,
                          left: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          zIndex: 50,
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                      >
                        <div>
                          <EditProfile setIsEditProfile={setIsEditProfile} />
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {matchingRequests.length > 0 ? (
                      <>
                        {matchingRequests[0].toUserId ===
                          selectedProject.userId &&
                        matchingRequests[0].userId === currentUser?.uid ? (
                          <div>
                            {matchingRequests[0].status === "Pending" ? (
                              <button
                                className="send-request-btn"
                                onClick={() =>
                                  handleCancelRequest(matchingRequests[0].id)
                                }
                              >
                                Cancel
                              </button>
                            ) : (
                              <button
                                onClick={
                                  matchingRequests[0].status === "Accepted"
                                    ? () => navigate("/inbox")
                                    : undefined
                                }
                                className="send-request-btn"
                              >
                                {matchingRequests[0].status === "Accepted"
                                  ? "Connected"
                                  : "Denied"}
                              </button>
                            )}
                          </div>
                        ) : matchingRequests[0].toUserId === currentUser?.uid &&
                          matchingRequests[0].userId ===
                            selectedProject.userId ? (
                          <div style={{ display: "flex", gap: "5px" }}>
                            {matchingRequests[0].status === "Pending" ? (
                              <>
                                <button
                                  onClick={() =>
                                    handleAccept(matchingRequests[0].id)
                                  }
                                  // style={{
                                  //   backgroundColor: "#4A4AFF",
                                  //   color: "#fff",
                                  //   padding: "10px 20px",
                                  //   borderRadius: "8px",
                                  //   border: "none",
                                  //   cursor: "pointer",
                                  //   fontSize: "14px",
                                  // }}
                                  className="send-request-btn"
                                >
                                  Accept
                                </button>
                                <button
                                  onClick={() =>
                                    handleDeny(matchingRequests[0].id)
                                  }
                                  // style={{
                                  //   backgroundColor: "#FF4A4A",
                                  //   color: "#fff",
                                  //   padding: "10px 20px",
                                  //   borderRadius: "8px",
                                  //   border: "none",
                                  //   cursor: "pointer",
                                  //   fontSize: "14px",
                                  // }}
                                  className="send-request-btn"
                                >
                                  Deny
                                </button>
                              </>
                            ) : (
                              <button className="send-request-btn">
                                {matchingRequests[0].status}
                              </button>
                            )}
                          </div>
                        ) : (
                          <>
                            <button
                              className="send-request-btn"
                              onClick={handleToggleModal}
                            >
                              Send Request
                            </button>

                            {/* Modal */}
                            {isModalOpen && (
                              <div
                                style={{
                                  position: "fixed",
                                  top: 0,
                                  right: 0,
                                  bottom: 0,
                                  left: 0,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  zIndex: 50,
                                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: "#fff",
                                    padding: "20px",
                                    borderRadius: "10px",
                                    width: "400px",
                                    maxWidth: "90%",
                                    border: "1px solid #ccc",
                                    boxShadow:
                                      "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                  }}
                                >
                                  <h2
                                    style={{
                                      marginBottom: "10px",
                                      fontSize: "18px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    Send Request
                                  </h2>

                                  {/* Request Type Dropdown */}
                                  <label
                                    style={{
                                      fontWeight: "600",
                                      fontSize: "14px",
                                      color: "#333",
                                    }}
                                  >
                                    Request Type
                                  </label>
                                  <div
                                    style={{
                                      border: "2px solid #4A4AFF", // Purple border
                                      borderRadius: "8px", // Rounded corners
                                      padding: "10px",
                                      position: "relative",
                                      marginBottom: "10px",
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      fontSize: "14px",
                                      color: "#333",
                                    }}
                                    onClick={() =>
                                      setIsRequestTypeOpen(!isRequestTypeOpen)
                                    }
                                  >
                                    <span>
                                      {requestTypes.length
                                        ? requestTypes.join(", ")
                                        : "Request Type"}
                                    </span>
                                    <span
                                      style={{
                                        transform: isRequestTypeOpen
                                          ? "rotate(180deg)"
                                          : "rotate(0)",
                                        color: "blue",
                                      }}
                                    >
                                      ▼
                                    </span>
                                  </div>
                                  {isRequestTypeOpen && (
                                    <div
                                      style={{
                                        border: "1px solid #4A4AFF",
                                        borderRadius: "8px",
                                        padding: "10px",
                                        marginBottom: "10px",
                                        backgroundColor: "#f9f9f9",
                                      }}
                                    >
                                      {[
                                        "Technical Collaboration",
                                        "Funding",
                                        "Listing",
                                        "Marketing",
                                        "Integrations",
                                        "Community Building",
                                        "Explore",
                                      ].map((type) => (
                                        <div
                                          key={type}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            marginBottom: "8px",
                                            padding: "4px 0",
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            value={type}
                                            checked={requestTypes.includes(
                                              type
                                            )}
                                            onChange={() =>
                                              handleRequestTypeChange(type)
                                            }
                                            style={{
                                              marginRight: "10px",
                                              width: "16px", // Fixed width for the checkbox
                                              height: "16px", // Fixed height for the checkbox
                                              border: "2px solid #4A4AFF", // Purple border for checkbox
                                              borderRadius: "4px", // Rounded checkbox
                                            }}
                                          />
                                          <label
                                            style={{
                                              fontSize: "14px",
                                              color: "#333",
                                              width: "100%",
                                            }}
                                          >
                                            {type}
                                          </label>
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  {/* Message */}
                                  <label
                                    style={{
                                      fontWeight: "600",
                                      display: "block",
                                      marginBottom: "5px",
                                      fontSize: "14px",
                                      color: "#333",
                                    }}
                                  >
                                    Message
                                  </label>
                                  {/* <textarea
                                    
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    placeholder="Message"
                                    style={{
                                      width: "100%",
                                      height: "120px",
                                      border: "1px solid #4A4AFF",
                                      borderRadius: "8px",
                                      padding: "12px 14px",
                                      marginBottom: "16px",
                                      fontSize: "14px",
                                      color: "#333",
                                      outline: "none",
                                      boxSizing: "border-box",
                                      resize: "none", // Prevent resizing of the textarea
                                    }}
                                  ></textarea> */}
                                  {/* <textarea
                                    value={message}
                                    onChange={(e) => {
                                      const inputMessage = e.target.value;
                                      if (inputMessage.length < 200) {
                                        toast(
                                          "Minimum  200 characters  to send  .", {
                                            position: "top-center", // Position the toast at the center top
                                            autoClose: 3000, // Automatically close after 3 seconds
                                            // hideProgressBar: true, // Hide the progress bar
                                            closeOnClick: true,
                                            pauseOnHover: true,
                                            draggable: true,
                                          }
                                        );
                                        return;
                                      }
                                      setMessage(inputMessage); // Update message if within the limit
                                    }}
                                    placeholder="Message"
                                    style={{
                                      width: "100%",
                                      height: "120px",
                                      border: "1px solid #4A4AFF",
                                      borderRadius: "8px",
                                      padding: "12px 14px",
                                      marginBottom: "16px",
                                      fontSize: "14px",
                                      color: "#333",
                                      outline: "none",
                                      boxSizing: "border-box",
                                      resize: "none", // Prevent resizing of the textarea
                                    }}
                                  ></textarea> */}
                                  <textarea
                                    value={message}
                                    onChange={handleMessageChange}
                                    placeholder="Write your message here..."
                                    style={{
                                      width: "100%",
                                      height: "120px",
                                      border: isInvalid
                                        ? "1px solid red"
                                        : "1px solid #4A4AFF", // Conditional border color
                                      borderRadius: "8px",
                                      padding: "12px 14px",
                                      marginBottom: "16px",
                                      fontSize: "14px",
                                      color: "#333",
                                      outline: "none",
                                      boxSizing: "border-box",
                                      resize: "none",
                                    }}
                                  ></textarea>

                                  {/* Buttons */}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <button
                                      onClick={() => {
                                        setIsModalOpen(!isModalOpen);
                                        setMessage("");
                                        setIsRequestTypeOpen(false);
                                      }}
                                      style={{
                                        backgroundColor: "#ccc",
                                        padding: "10px 20px",
                                        borderRadius: "8px",
                                        border: "none",
                                        cursor: "pointer",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      onClick={handleSendSaveRequest}
                                      style={{
                                        backgroundColor: "#4A4AFF",
                                        color: "#fff",
                                        padding: "10px 20px",
                                        borderRadius: "8px",
                                        border: "none",
                                        cursor: "pointer",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Send
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {/* If no matching request exists, show the "Send Request" button */}
                        <button
                          className="send-request-btn"
                          onClick={handleToggleModal}
                        >
                          Send Request
                        </button>

                        {/* Modal */}
                        {isModalOpen && (
                          <div
                            style={{
                              position: "fixed",
                              top: 0,
                              right: 0,
                              bottom: 0,
                              left: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 50,
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: "#fff",
                                padding: "20px",
                                borderRadius: "10px",
                                width: "400px",
                                maxWidth: "90%",
                                border: "1px solid #ccc",
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              <h2
                                style={{
                                  marginBottom: "10px",
                                  fontSize: "18px",
                                  fontWeight: "600",
                                }}
                              >
                                Send Requests
                              </h2>

                              {/* Request Type Dropdown */}
                              <label
                                style={{
                                  fontWeight: "600",
                                  fontSize: "14px",
                                  color: "#333",
                                }}
                              >
                                Request Type
                              </label>
                              <div
                                style={{
                                  border: "2px solid #4A4AFF", // Purple border
                                  borderRadius: "8px", // Rounded corners
                                  padding: "10px",
                                  position: "relative",
                                  marginBottom: "10px",
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  fontSize: "14px",
                                  color: "#333",
                                }}
                                onClick={() =>
                                  setIsRequestTypeOpen(!isRequestTypeOpen)
                                }
                              >
                                <span>
                                  {requestTypes.length
                                    ? requestTypes.join(", ")
                                    : "Request Type"}
                                </span>
                                <span
                                  style={{
                                    transform: isRequestTypeOpen
                                      ? "rotate(180deg)"
                                      : "rotate(0)",
                                    color: "blue",
                                  }}
                                >
                                  ▼
                                </span>
                              </div>
                              {isRequestTypeOpen && (
                                <div
                                  style={{
                                    border: "1px solid #4A4AFF",
                                    borderRadius: "8px",
                                    padding: "10px",
                                    marginBottom: "10px",
                                    backgroundColor: "#f9f9f9",
                                  }}
                                >
                                  {[
                                    "Technical Collaboration",
                                    "Funding",
                                    "Listing",
                                    "Marketing",
                                    "Integrations",
                                    "Community Building",
                                    "Explore",
                                  ].map((type) => (
                                    <div
                                      key={type}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginBottom: "8px",
                                        padding: "4px 0",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        value={type}
                                        checked={requestTypes.includes(type)}
                                        onChange={() =>
                                          handleRequestTypeChange(type)
                                        }
                                        style={{
                                          marginRight: "10px",
                                          width: "16px", // Fixed width for the checkbox
                                          height: "16px", // Fixed height for the checkbox
                                          border: "2px solid #4A4AFF", // Purple border for checkbox
                                          borderRadius: "4px", // Rounded checkbox
                                        }}
                                      />
                                      <label
                                        style={{
                                          fontSize: "14px",
                                          color: "#333",
                                          width: "100%",
                                        }}
                                      >
                                        {type}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              )}

                              {/* Message */}
                              <label
                                style={{
                                  fontWeight: "600",
                                  display: "block",
                                  marginBottom: "5px",
                                  fontSize: "14px",
                                  color: "#333",
                                }}
                              >
                                Message
                              </label>
                              <textarea
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="Message"
                                style={{
                                  width: "100%",
                                  height: "120px",
                                  border: "1px solid #4A4AFF",
                                  borderRadius: "8px",
                                  padding: "12px 14px",
                                  marginBottom: "16px",
                                  fontSize: "14px",
                                  color: "#333",
                                  outline: "none",
                                  boxSizing: "border-box",
                                  resize: "none", // Prevent resizing of the textarea
                                }}
                              ></textarea>

                              {/* Buttons */}
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <button
                                  onClick={() => {
                                    setIsModalOpen(!isModalOpen);
                                    setMessage("");
                                    setIsRequestTypeOpen(false);
                                  }}
                                  style={{
                                    backgroundColor: "#ccc",
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                  }}
                                >
                                  Cancel
                                </button>
                                <button
                                  onClick={handleSendSaveRequest}
                                  style={{
                                    backgroundColor: "#4A4AFF",
                                    color: "#fff",
                                    padding: "10px 20px",
                                    borderRadius: "8px",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                  }}
                                >
                                  Send
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}

                <div className="funding-btn1">
                  Funding Stage:{" "}
                  {selectedProject?.userId === currentUser?.uid
                    ?myproject?.fundingStatus?.join(",")
                    :selectedProject?.fundingStatus?.join(",")}
                </div>
              </div>
              <div className="funding-btn1-m">
                {selectedProject?.userId === currentUser?.uid
                  ? myproject?.fundingStatus?.join(",")
                  : selectedProject?.fundingStatus?.join(",")}
              </div>
            </div>
          </div>

          {/* Main Body */}
          <div className="main-content1">
            {/* Left Section */}
            <div className="left-section1">
              {/* Biodata */}
              <div className="biodata-card1">
                <p className="biodata-heading">Description</p>
                <p className="biodata-text">
                  {selectedProject.userId === currentUser?.uid
                    ? myproject?.biodata || ""
                    : selectedProject?.biodata || ""}
                </p>
              </div>

              {/* Ecosystem */}

              <div className="ecosystem-card1">
                <p className="ecosystem-heading">Ecosystem</p>
                <div className="ecosystem-text">
                  {blockchains
                    .sort((a, b) =>
                      a.toLowerCase().localeCompare(b.toLowerCase())
                    ) // Case-insensitive alphabetical sorting
                    .slice(0, showAllBlockchains ? blockchains.length : 9) // Show first 14 or all if toggled
                    .map((blockchain, index) => (
                      <span key={index} className="category-item">
                        {blockchain}
                      </span>
                    ))}

                  {/* 'Show More' functionality for blockchains */}
                  {!showAllBlockchains && blockchains.length > 9 && (
                    <>
                      <span
                        className="category-more"
                        onClick={() => setShowMoreEc(true)}
                      >
                        +{blockchains.length - 9} More
                      </span>
                      {showMoreEc && (
                        <Modal
                          maplist={blockchains.slice(9, blockchains.length)}
                          onClose={closeModal}
                        />
                      )}
                    </>
                  )}
                </div>
              </div>

              {/* Partnership Interest */}
              <div className="partnership-card1">
                <p className="partnership-heading">Partnership Interests </p>
                <div className="partnership-text">
                  {partnershipInterests
                    .sort((a, b) =>
                      a.toLowerCase().localeCompare(b.toLowerCase())
                    ) // Case-insensitive alphabetical sorting
                    .slice(
                      0,
                      showAllPartnerships ? partnershipInterests.length : 9
                    ) // Show first 9 or all if toggled
                    .map((interest, index) => (
                      <span key={index} className="category-item">
                        {interest}
                      </span>
                    ))}

                  {!showAllPartnerships && partnershipInterests.length > 9 && (
                    <span
                      className="category-more"
                      /* onClick={() => setShowAllPartnerships(true)} */
                      onClick={() => setShowMorePi(true)}
                    >
                      +{partnershipInterests.length - 9} More
                    </span>
                  )}
                  {showMorePi && (
                    <Modal
                      maplist={partnershipInterests.slice(
                        9,
                        partnershipInterests.length
                      )}
                      onClose={closeModal}
                    />
                  )}
                </div>
              </div>

              {/* Whitepaper */}
              <div className="whitepaper-card1">
                {console.log(
                  "Matching request status:",
                  matchingRequests?.status
                )}
                <p className="whitepaper-heading">
                  Whitepaper:
                  {/* <a className="whitepaper-text">
                    {selectedProject.userId === currentUser?.uid
                      ? myproject?.whitepaper || ""
                      : selectedProject?.whitepaper}
                  </a> */}
                  <a
                    className="whitepaper-text"
                    title={
                      selectedProject.userId === currentUser?.uid
                        ? myproject?.whitepaper || ""
                        : selectedProject?.whitepaper || ""
                    }
                    onClick={() => {
                      const url =
                        selectedProject.userId === currentUser?.uid
                          ? myproject?.whitepaper || ""
                          : selectedProject?.whitepaper;

                      if (url) {
                        window.open(url, "_blank"); // Open the URL in a new tab
                      }
                    }}
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                  >
                    {selectedProject.userId === currentUser?.uid
                      ? myproject?.whitepaper || ""
                      : selectedProject?.whitepaper || ""}
                  </a>
                </p>
              </div>

              {/* Statement for Projects */}
              <div className="statement-card1">
                <p className="statement-heading">Statement for projects</p>
                <p className="statement-text">
                  {selectedProject.userId === currentUser?.uid
                    ? myproject?.descr || ""
                    : selectedProject?.descr}
                </p>
              </div>
            </div>

            <div className="right-section-companydetails">
              <div className="companydetails-request-container">
                <div className="stat-item1">
                  <div className="stat-item1-left">
                    <img
                      src={acceptsvg}
                      alt="logo"
                      className="received1-img1"
                    />
                    <span className="stat-item1-text">Requests Received</span>
                  </div>

                  <div className="number-section">
                    <p className="number-stat">
                      {" "}
                      {String(requestReceived).padStart(3, "0")}
                    </p>
                  </div>
                </div>

                <div className="stat-item1">
                  <div className="stat-item1-left">
                    <img src={sentsvg} alt="logo" className="received1-img1" />
                    <span className="stat-item1-text">Requests Sent</span>
                  </div>
                  <div className="number-section">
                    <p className="number-stat" style={{ color: "white" }}>
                      {String(requestSent).padStart(3, "0")}
                    </p>
                  </div>
                </div>
              </div>

              {/* <div className="categories-card1">
              <p className="categories-heading">Categories</p>
              <p className="categories-text">
             {(selectedProject.userId===currentUser?.uid)?(myproject?.category || ""):(selectedProject?.category || "")} 

              </p>
            </div> */}
              {/* <div className="categories-card1">
  <p className="categories-heading">Categories</p>
  <div className="categories-text">
    {(selectedProject.userId === currentUser?.uid)
      ? (myproject?.category?.length > 0 ? (
          myproject.category.map((cat, index) => (
            <p key={index} className="category-item">{cat}</p>
          ))
        ) : (
          <p>No categories available</p>
        ))
      : (selectedProject?.category?.length > 0 ? (
          selectedProject.category.map((cat, index) => (
            <p key={index} className="category-item">{cat}</p>
          ))
        ) : (
          <p>No categories available</p>
        ))
    }
  </div>
</div> */}

              <div className="categories-card1">
                <p className="categories-heading">Categories</p>

                <div className="categories-text">
                  {categories
                    .sort((a, b) =>
                      a.toLowerCase().localeCompare(b.toLowerCase())
                    ) // Case-insensitive alphabetical sorting
                    .slice(0, showAllCategories ? categories.length : 14) // Show first 14 or all if toggled
                    .map((cat, index) => (
                      <span key={index} className="category-item">
                        {cat}
                      </span>
                    ))}
                  {!showAllCategories && categories.length > 14 && (
                    <span
                      className="category-more"
                      // onClick={() => setShowAllCategories(true)}
                      onClick={handleMoreClick}
                    >
                      +{categories.length - 14} More
                    </span>
                  )}
                  {showMore && (
                    <Modal
                      maplist={categories.slice(14, categories.length)}
                      onClose={closeModal}
                    />
                  )}

                  {/* {selectedProject.userId === currentUser?.uid
                    ? myproject?.category || ""
                    : selectedProject?.category || ""} */}
                </div>
              </div>

              <div className="request-type-card1">
                <p className="request-type-heading">Request Type</p>
                <div className="request-type-text">
                  {requesttypes
                    .sort((a, b) =>
                      a.toLowerCase().localeCompare(b.toLowerCase())
                    ) // Case-insensitive alphabetical sorting
                    .slice(0, showAllRequestTypes ? requesttypes.length : 14) // Show first 14 or all if toggled
                    .map((type, index) => (
                      <span key={index} className="category-item">
                        {type}
                      </span>
                    ))}

                  {!showAllRequestTypes && requesttypes.length > 14 && (
                    <span
                      className="category-more"
                      onClick={() => setShowAllRequestTypes(true)}
                    >
                      +{requestTypes.length - 14} More
                    </span>
                  )}
                </div>
              </div>

              <div className="social-media-card1">
                <p className="social-media-heading">Social Media</p>
                <div className="social-media-flex">
                  <div className="social-media-text">
                    <div
                      className="containericon"
                      onClick={() => {
                        if (selectedProject?.userId === currentUser?.uid) {
                          if (myproject?.telegramLink) {
                            window.open(myproject?.telegramLink, "_blank");
                          } else {
                            toast("Unavailable Link", {
                              position: "top-center",
                              autoClose: 3000,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                            });
                          }
                        } else {
                          if (selectedProject?.telegramLink) {
                            window.open(
                              selectedProject?.telegramLink,
                              "_blank"
                            );
                          } else {
                            toast("Unavailable Link", {
                              position: "top-center",
                              autoClose: 3000,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                            });
                          }
                        }
                      }}
                    >
                      <svg
                        className="icon-svg"
                        width="20"
                        height="17"
                        viewBox="0 0 20 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M1.6975 7.41086C6.8654 5.15929 10.3115 3.67491 12.0357 2.95774C16.9588 0.910055 17.9818 0.554351 18.6486 0.542606C18.7952 0.540022 19.1231 0.576366 19.3355 0.748711C19.5148 0.894235 19.5642 1.09082 19.5878 1.22879C19.6114 1.36676 19.6408 1.68107 19.6174 1.92666C19.3507 4.72978 18.1963 11.5322 17.609 14.6718C17.3605 16.0002 16.8712 16.4456 16.3975 16.4892C15.368 16.584 14.5863 15.8089 13.5892 15.1553C12.029 14.1325 11.1475 13.4959 9.63306 12.4978C7.88281 11.3444 9.01742 10.7105 10.0149 9.67452C10.2759 9.40339 14.8118 5.2777 14.8996 4.90343C14.9105 4.85662 14.9207 4.68215 14.8171 4.59001C14.7134 4.49788 14.5604 4.52939 14.45 4.55445C14.2936 4.58996 11.801 6.23742 6.97251 9.49681C6.26502 9.98263 5.6242 10.2193 5.05004 10.2069C4.41708 10.1933 3.19952 9.84904 2.29439 9.55482C1.1842 9.19394 0.301855 9.00315 0.378687 8.39027C0.418707 8.07104 0.85831 7.74457 1.6975 7.41086Z"
                          fill="#003BFF"
                        />
                      </svg>
                    </div>

                    <div
                      className="containericon"
                      onClick={() => {
                        if (selectedProject?.userId === currentUser?.uid) {
                          if (myproject?.redditLink) {
                            window.open(myproject?.redditLink, "_blank");
                          } else {
                            toast("Unavailable Link", {
                              position: "top-center",
                              autoClose: 3000,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                            });
                          }
                        } else {
                          if (selectedProject?.redditLink) {
                            window.open(selectedProject?.redditLink, "_blank");
                          } else {
                            toast("Unavailable Link", {
                              position: "top-center",
                              autoClose: 3000,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                            });
                          }
                        }
                      }}
                    >
                      <svg
                        className="icon-svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_4121_453)">
                          <path
                            d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
                            fill="#003CFF"
                          />
                          <path
                            class="inside"
                            d="M16.67 9.99992C16.672 10.1369 16.655 10.2737 16.619 10.4059C16.583 10.5382 16.5285 10.6649 16.457 10.7819C16.3858 10.8989 16.2983 11.0054 16.1973 11.0982C16.0963 11.1909 15.9828 11.2689 15.86 11.3299C15.8628 11.3664 15.865 11.4032 15.8663 11.4399C15.8693 11.5132 15.8693 11.5866 15.8663 11.6599C15.865 11.6967 15.8628 11.7334 15.86 11.7699C15.86 14.01 13.25 15.83 10.03 15.83C6.80994 15.83 4.19991 14.01 4.19991 11.7699C4.19716 11.7334 4.19491 11.6967 4.19366 11.6599C4.19065 11.5866 4.19065 11.5132 4.19366 11.4399C4.19491 11.4032 4.19716 11.3664 4.19991 11.3299C4.0076 11.2415 3.83679 11.1124 3.69931 10.9515C3.56182 10.7906 3.46094 10.6017 3.40366 10.3979C3.34646 10.1941 3.33428 9.98023 3.36795 9.7712C3.40162 9.56218 3.48034 9.36298 3.59866 9.18741C3.71687 9.01186 3.87186 8.86414 4.05287 8.75448C4.23388 8.64483 4.43659 8.57588 4.64692 8.5524C4.85727 8.52882 5.07024 8.55127 5.27106 8.61818C5.47188 8.68509 5.65575 8.79487 5.80993 8.9399C6.09614 8.74591 6.39601 8.57287 6.70719 8.42215C7.01844 8.27165 7.34019 8.14365 7.66994 8.03964C7.9997 7.93564 8.3367 7.85589 8.67795 7.80064C9.01921 7.74539 9.36421 7.71514 9.70996 7.70989L10.45 4.23986C10.4582 4.19961 10.4745 4.16161 10.4977 4.1276C10.5207 4.09385 10.5505 4.06485 10.5847 4.0426C10.6192 4.02035 10.6577 4.0051 10.6982 3.9976C10.7385 3.99035 10.78 3.9911 10.82 3.99985L13.27 4.48986C13.5172 4.0651 14.0363 3.8831 14.4945 4.0601C14.9528 4.23711 15.2148 4.72086 15.1123 5.20137C15.01 5.68187 14.5735 6.01687 14.083 5.99162C13.5922 5.96637 13.1925 5.58837 13.14 5.09986L11 4.64986L10.35 7.76989C10.6915 7.77714 11.0322 7.80914 11.3692 7.86539C12.0441 7.97789 12.6992 8.18721 13.3142 8.4869C13.6214 8.6364 13.9175 8.80785 14.2 8.9999C14.4032 8.80485 14.6584 8.67279 14.935 8.61965C15.2116 8.56633 15.4977 8.5942 15.7588 8.6999C16.0199 8.80555 16.2448 8.9845 16.4065 9.21516C16.5683 9.44583 16.6598 9.71838 16.67 9.99992ZM6.74594 11.3827C6.79644 11.5039 6.86994 11.6142 6.96294 11.7069C7.05569 11.7999 7.16594 11.8734 7.28719 11.9239C7.40856 11.9741 7.53861 12 7.66994 11.9999C8.07445 11.9999 8.43895 11.7562 8.59395 11.3827C8.7487 11.0089 8.66295 10.5789 8.37695 10.2929C8.09095 10.0069 7.66094 9.92116 7.28719 10.0759C6.91369 10.2309 6.66994 10.5954 6.66994 10.9999C6.66994 11.1312 6.69569 11.2612 6.74594 11.3827ZM12.4735 13.7832C12.5247 13.7332 12.554 13.665 12.555 13.5935C12.556 13.5217 12.5282 13.4527 12.4782 13.4014C12.4282 13.3502 12.36 13.3209 12.2885 13.3199C12.2167 13.3189 12.1477 13.3467 12.09 13.3899C11.9396 13.4978 11.7804 13.5927 11.614 13.6737C11.4476 13.7547 11.2746 13.8215 11.097 13.8735C10.9195 13.9252 10.7377 13.962 10.554 13.9832C10.37 14.0045 10.1847 14.01 9.99997 14C9.81546 14.0082 9.63046 14.0007 9.44721 13.9777C9.26392 13.9549 9.08292 13.9165 8.90621 13.8627C8.7292 13.8092 8.55745 13.7407 8.3922 13.6582C8.22695 13.5757 8.06895 13.4792 7.91995 13.3699C7.8682 13.3274 7.80245 13.3057 7.73545 13.3089C7.66845 13.3122 7.60519 13.3404 7.55769 13.3877C7.51044 13.4352 7.48219 13.4985 7.47894 13.5655C7.47569 13.6325 7.49744 13.6982 7.53994 13.75C7.7157 13.8825 7.90245 13.9995 8.0982 14.1C8.29395 14.2005 8.4982 14.2837 8.7082 14.3492C8.91821 14.4147 9.13346 14.462 9.35171 14.4907C9.56996 14.5192 9.79021 14.529 10.01 14.52C10.2297 14.529 10.45 14.5192 10.6682 14.4907C11.1054 14.4332 11.5294 14.301 11.9217 14.1C12.1175 13.9995 12.3042 13.8825 12.48 13.75L12.4735 13.7832ZM12.29 12.0799C12.4255 12.0814 12.56 12.0552 12.6852 12.0032C12.8105 11.9509 12.9237 11.8739 13.0182 11.7767C13.1127 11.6794 13.1862 11.5639 13.2347 11.4372C13.2833 11.3106 13.3055 11.1754 13.3 11.0399C13.3 10.6354 13.0562 10.2709 12.6827 10.1159C12.309 9.96116 11.879 10.0469 11.593 10.3329C11.307 10.6189 11.2212 11.0489 11.376 11.4227C11.531 11.7962 11.8955 12.0399 12.3 12.0399L12.29 12.0799Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_4121_453">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      {/* <img
                      src={Reddit}
                      alt="Reddit"
                      onClick={() => {
                        if (selectedProject?.userId === currentUser?.uid) {
                          if (myproject?.redditLink) {
                            window.open(myproject?.redditLink, "_blank");
                          } else {
                            alert("Unavailable Link");
                          }
                        } else {
                          if (selectedProject?.redditLink) {
                            window.open(selectedProject?.redditLink, "_blank");
                          } else {
                            alert("Unavailable Link");
                          }
                        }
                      }}
                    /> */}
                    </div>
                    <div
                      className="containericon"
                      onClick={() => {
                        if (selectedProject?.userId === currentUser?.uid) {
                          if (myproject?.mediumLink) {
                            window.open(myproject?.mediumLink, "_blank");
                          } else {
                            toast("Unavailable Link", {
                              position: "top-center",
                              autoClose: 3000,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                            });
                          }
                        } else {
                          if (selectedProject?.mediumLink) {
                            window.open(selectedProject?.mediumLink, "_blank");
                          } else {
                            toast("Unavailable Link", {
                              position: "top-center",
                              autoClose: 3000,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                            });
                          }
                        }
                      }}
                    >
                      <svg
                        className="icon-svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.2812 10.0002C11.2812 15.5229 8.75579 20 5.6407 20C2.52561 20 0 15.5219 0 10.0002C0 4.47841 2.52542 0 5.6407 0C8.75598 0 11.2812 4.4774 11.2812 10.0002Z"
                          fill="#003BFF"
                        />
                        <path
                          d="M17.4691 9.99983C17.4691 15.1983 16.2064 19.4142 14.6487 19.4142C13.0911 19.4142 11.8284 15.1983 11.8284 9.99983C11.8284 4.80134 13.0909 0.585449 14.6485 0.585449C16.2062 0.585449 17.4689 4.79999 17.4689 9.99983"
                          fill="#003BFF"
                        />
                        <path
                          d="M20 10.0002C20 14.6568 19.556 18.434 19.0081 18.434C18.4602 18.434 18.0164 14.6578 18.0164 10.0002C18.0164 5.34262 18.4604 1.56641 19.0081 1.56641C19.5558 1.56641 20 5.34228 20 10.0002Z"
                          fill="#003BFF"
                        />
                      </svg>
                      {/* <img
                      src={Group}
                      alt="Group"
                      onClick={() => {
                        if (selectedProject?.userId === currentUser?.uid) {
                          if (myproject?.mediumLink) {
                            window.open(myproject?.mediumLink, "_blank");
                          } else {
                            alert("Unavailable Link");
                          }
                        } else {
                          if (selectedProject?.mediumLink) {
                            window.open(selectedProject?.mediumLink, "_blank");
                          } else {
                            alert("Unavailable Link");
                          }
                        }
                      }}
                    /> */}
                    </div>
                    <div
                      className="containericon"
                      onClick={() => {
                        if (selectedProject?.userId === currentUser?.uid) {
                          if (myproject?.twitterLink) {
                            window.open(myproject?.twitterLink, "_blank");
                          } else {
                            toast("Unavailable Link", {
                              position: "top-center",
                              autoClose: 3000,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                            });
                          }
                        } else {
                          if (selectedProject?.twitterLink) {
                            window.open(selectedProject?.twitterLink, "_blank");
                          } else {
                            toast("Unavailable Link", {
                              position: "top-center",
                              autoClose: 3000,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                            });
                          }
                        }
                      }}
                    >
                      <svg
                        className="icon-svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.25472 18.0025C13.7602 18.0025 17.8646 11.8202 17.8646 6.45913C17.8646 6.28355 17.861 6.10878 17.8531 5.93474C18.6517 5.36017 19.3409 4.64876 19.8885 3.83387C19.1573 4.15706 18.3706 4.37457 17.5452 4.47265C18.3877 3.97039 19.0344 3.17581 19.3396 2.22867C18.5386 2.70111 17.6623 3.03416 16.7485 3.21345C16.0039 2.42486 14.9438 1.93164 13.77 1.93164C11.5166 1.93164 9.68928 3.74853 9.68928 5.98813C9.68928 6.30653 9.72514 6.61614 9.79515 6.91321C6.40381 6.74354 3.3966 5.12914 1.38403 2.67436C1.02154 3.2935 0.830883 3.99717 0.831516 4.71351C0.831516 6.12108 1.55187 7.36364 2.64735 8.0906C1.99936 8.07093 1.36559 7.8969 0.799339 7.58316C0.798732 7.6002 0.798732 7.61679 0.798732 7.63499C0.798732 9.59978 2.20524 11.2403 4.07233 11.612C3.72166 11.7069 3.35981 11.7549 2.99637 11.7547C2.7339 11.7547 2.4781 11.729 2.22949 11.6816C2.74898 13.2936 4.25532 14.4666 6.04129 14.4994C4.64469 15.5878 2.88541 16.236 0.973322 16.236C0.648053 16.2363 0.323049 16.2176 0 16.1798C1.80589 17.3307 3.95021 18.0022 6.25492 18.0022"
                          fill="#003CFF"
                        />
                      </svg>

                      {/* <img
                      src={Twitter}
                      alt="Twitter"
                      onClick={() => {
                        if (selectedProject?.userId === currentUser?.uid) {
                          if (myproject?.twitterLink) {
                            window.open(myproject?.twitterLink, "_blank");
                          } else {
                            alert("Unavailable Link");
                          }
                        } else {
                          if (selectedProject?.twitterLink) {
                            window.open(selectedProject?.twitterLink, "_blank");
                          } else {
                            alert("Unavailable Link");
                          }
                        }
                      }}
                    /> */}
                    </div>
                    <div
                      className="containericon"
                      onClick={() => {
                        if (selectedProject?.userId === currentUser?.uid) {
                          if (myproject?.githubLink) {
                            window.open(myproject?.githubLink, "_blank");
                          } else {
                            toast("Unavailable Link", {
                              position: "top-center",
                              autoClose: 3000,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                            });
                          }
                        } else {
                          if (selectedProject?.githubLink) {
                            window.open(selectedProject?.githubLink, "_blank");
                          } else {
                            toast("Unavailable Link", {
                              position: "top-center",
                              autoClose: 3000,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                            });
                          }
                        }
                      }}
                    >
                      <svg
                        className="icon-svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M0 8C0 5.19974 0 3.79961 0.544967 2.73005C1.02433 1.78924 1.78924 1.02433 2.73005 0.544967C3.79961 0 5.19974 0 8 0H12C14.8003 0 16.2004 0 17.27 0.544967C18.2108 1.02433 18.9757 1.78924 19.455 2.73005C20 3.79961 20 5.19974 20 8V12C20 14.8003 20 16.2004 19.455 17.27C18.9757 18.2108 18.2108 18.9757 17.27 19.455C16.2004 20 14.8003 20 12 20H8C5.19974 20 3.79961 20 2.73005 19.455C1.78924 18.9757 1.02433 18.2108 0.544967 17.27C0 16.2004 0 14.8003 0 12V8ZM2.5 10C2.5 5.85812 5.85625 2.5 10 2.5C14.1419 2.5 17.5 5.85812 17.5 10C17.5 13.3094 15.3531 16.1219 12.3525 17.1056C11.9681 17.1806 11.8369 16.9463 11.8369 16.7494C11.8369 16.6689 11.8379 16.5271 11.8393 16.3372C11.842 15.9518 11.8462 15.368 11.8462 14.6956C11.8462 13.9931 11.6025 13.5331 11.34 13.3081C13.0087 13.1237 14.7619 12.4894 14.7619 9.60812C14.7619 8.78937 14.4712 8.12062 13.9931 7.59562C14.0681 7.40625 14.3212 6.64375 13.9181 5.61062C13.9181 5.61062 13.29 5.40937 11.865 6.37937C11.265 6.2125 10.6275 6.13 9.99 6.12625C9.3525 6.13 8.715 6.2125 8.115 6.37937C6.68062 5.40937 6.0525 5.61062 6.0525 5.61062C5.64937 6.64375 5.9025 7.40625 5.98687 7.59562C5.50562 8.12062 5.215 8.78937 5.215 9.60812C5.215 12.4819 6.96563 13.1269 8.63125 13.3144C8.41687 13.5019 8.22375 13.8325 8.15625 14.3175C7.7275 14.5094 6.64062 14.8406 5.97187 13.6937C5.97187 13.6937 5.57625 12.9737 4.82312 12.9212C4.82312 12.9212 4.09125 12.9119 4.77063 13.3769C4.77063 13.3769 5.26375 13.6081 5.605 14.4737C5.605 14.4737 6.045 15.9325 8.13125 15.48C8.13299 15.8271 8.13568 16.1269 8.13774 16.3554C8.13939 16.5385 8.14062 16.6758 8.14062 16.755C8.14062 16.9544 8.00313 17.1862 7.62812 17.1156C4.64875 16.125 2.5 13.3144 2.5 10Z"
                          fill="#003BFF"
                        />
                      </svg>

                      {/* <img
                      src={Git}
                      alt="Git"
                      onClick={() => {
                        if (selectedProject?.userId === currentUser?.uid) {
                          if (myproject?.githubLink) {
                            window.open(myproject?.githubLink, "_blank");
                          } else {
                            alert("Unavailable Link");
                          }
                        } else {
                          if (selectedProject?.githubLink) {
                            window.open(selectedProject?.githubLink, "_blank");
                          } else {
                            alert("Unavailable Link");
                          }
                        }
                      }}
                    /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {insufficientOpen && (
          <div className="inbox-popup-overlay">
            <InsufficientRequests setInsufficientOpen={setInsufficientOpen} />
          </div>
        )}

        <div className="companydetails-footer">
          <Footer />
        </div>
      </div>
      <ToastContainer
        toastStyle={{
          position: "absolute",
          margin: "auto",
          alignContent: "center",
          top: "10px", // Force position closer to the top
          transform: "translateY(-50%)", // Adjust to vertically center at the very top
        }}
      />
    </div>
  );
};

export default CompanyDetails;
